'use client';
import { useSuspenseQuery } from '@tanstack/react-query';

import Container from '@/components/@base/container';
import { CONTAINER_TAG_TYPE } from '@/components/@base/container/type';
import Props from '@/components/app/dynamic-content/components/type';
import { getDynamicPageContentOptions } from '@/components/app/dynamic-content/services/hooks';
import useReplaceOembedWithVideo from '@/components/shared/helpers/hooks/use-replace-ombed-with-video';

export default function DynamicContent({ pageId }: Props) {
  const { data: pageContent, isLoading } = useSuspenseQuery(
    getDynamicPageContentOptions(pageId),
  );
  const contentRef = useReplaceOembedWithVideo({ htmlContent: pageContent });

  return (
    <Container
      type={CONTAINER_TAG_TYPE.MAIN} className='w-full bg-[#F9FAFC]'>
      {isLoading ? (
        <Container>loading</Container>
      ) : pageContent ? (
        <Container className='m-4 max-w-[1279px] rounded-lg bg-[#FFFFFF] px-3.5 py-[15px] shadow-[0px_10px_25px_0px_#969BA41A] md:mx-auto md:my-5 md:px-[30px] md:py-9'>
          <Container
            className='custom-inner-html'
            ref={contentRef}
            dangerouslySetInnerHTML={{ __html: pageContent }}
          />
        </Container>
      ) : null}
    </Container>
  );
}
